import { Aggregator, AggregatorPromotion } from '../domain/types';
import { ThemeIcons } from '../theme/icons';

export const aggregatorIcons: Record<Aggregator, ThemeIcons> = {
  [Aggregator.IMMOBILIARE_IT]: ThemeIcons.IMMOBILIARE,
  [Aggregator.CASA_IT]: ThemeIcons.CASA,
  [Aggregator.IDEALISTA]: ThemeIcons.IDEALISTA,
  [Aggregator.WIKICASA]: ThemeIcons.WIKICASA,
  [Aggregator.GATE_AWAY]: ThemeIcons.GATE_AWAY,
  [Aggregator.DOVE_IT]: ThemeIcons.DOVE,
  [Aggregator.JAMES_EDITION]: ThemeIcons.JAMES_EDITION,
};

export const aggregatorLabels: Record<Aggregator, string> = {
  [Aggregator.DOVE_IT]: 'dove.it',
  [Aggregator.IMMOBILIARE_IT]: 'immobiliare.it',
  [Aggregator.IDEALISTA]: 'idealista',
  [Aggregator.WIKICASA]: 'wikicasa',
  [Aggregator.CASA_IT]: 'casa.it',
  [Aggregator.GATE_AWAY]: 'gate-away.com',
  [Aggregator.JAMES_EDITION]: 'jamesedition.com',
};

export const aggregatorPromotionLabels: Record<AggregatorPromotion, string> = {
  [AggregatorPromotion.VETRINA]: 'Vetrina',
  [AggregatorPromotion.STAR]: 'Star',
  [AggregatorPromotion.TOP]: 'Top',
  [AggregatorPromotion.SKY]: 'Sky',
  [AggregatorPromotion.PREMIUM]: 'Premium',
};

export const enabledAggregatorPromotion = [Aggregator.DOVE_IT, Aggregator.IMMOBILIARE_IT];
